const COEFFICIENT_FOR_MILES = 0.621371;

export const kmToMiles = (km?: number) => {
  if (!km) return 0;

  if (typeof km !== 'number') return 0;

  return (km * COEFFICIENT_FOR_MILES).toFixed();
};
